import { createClient } from './http';

const AI_API_BASE = import.meta.env.VITE_AI_API_BASE_URL ?? 'https://x-gis.xenus.dev/api/ai';

const request = createClient(AI_API_BASE);

export type InsightCard = {
  type: 'summary' | 'risk' | 'forecast' | 'info';
  title: string;
  text: string;
};

export type AnalyzeResponse = {
  area_sq_m: number;
  area_label: string;
  region: string | null;
  feature_count: number;
  osm_count: number;
  insights: InsightCard[];
  context: string;
};

export type ChatMessage = {
  role: 'user' | 'assistant';
  content: string;
};

export const aiApi = {
  analyze: (mapId: string, geometry: { type: string; coordinates: unknown }): Promise<AnalyzeResponse> =>
    request<AnalyzeResponse>('/analyze', { method: 'POST', body: JSON.stringify({ map_id: mapId, geometry }) }, true),

  chat: (context: string, messages: ChatMessage[]): Promise<{ reply: string }> =>
    request<{ reply: string }>('/chat', { method: 'POST', body: JSON.stringify({ context, messages }) }, true),
};
